
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.202 6.31a.43.43 0 000-.62L2.092.304c-.174-.182-.454-.182-.594 0l-.7.728c-.175.146-.175.437 0 .619l4.13 4.332-4.13 4.368a.43.43 0 000 .619l.7.728c.14.182.42.182.595 0l5.109-5.388z","fill":"#000","fill-opacity":".6"}})])
          )
        }
      }
    